import { Fragment, ReactElement, useState } from "react";
import "./styles.scss";
import { ViewerApi } from "@bronte/viewer-api/src/main";
import { DrawerTypes } from "../../shared/types";
interface IMenu {
  onMenuItemClick: (menuItemType: DrawerTypes | null) => void;
  parentActivityId?: string;
  viewerApi: ViewerApi;
}

export const Menu = ({ onMenuItemClick, parentActivityId, viewerApi }: IMenu): ReactElement => {
  const [showMenu, setShowMenu] = useState(true);

  const toggleMenu = (): void => {
    showMenu && onMenuItemClick(null); // If menu is open then sending null means close all the drawers.
    setShowMenu(!showMenu);
  };

  return (
    <Fragment>
      {showMenu ? (
        <div className="menu">
          <div className="menu-items">
            <button className="menu-item home" aria-label="Home"></button>
            <hr />
            <button
              className="menu-item toc"
              aria-label="Table of Contents"
              onClick={(): void => onMenuItemClick(DrawerTypes.TOC)}
            ></button>
            <button className="menu-item navigation" aria-label="Navigation"></button>
            <button
              className="menu-item search"
              aria-label="Search"
              onClick={() => onMenuItemClick(DrawerTypes.SEARCH)}
            ></button>
            <hr />
            <button
              className="menu-item audiobook"
              aria-label="Audiobook"
              onClick={() => onMenuItemClick(DrawerTypes.AUDIOBOOK)}
            ></button>
            <button
              className="menu-item notebook"
              aria-label="Notebook"
              onClick={() => onMenuItemClick(DrawerTypes.NOTEBOOK)}
            ></button>
            <button
              className="menu-item study"
              aria-label="Study"
              onClick={() => onMenuItemClick(DrawerTypes.FLASHCARD)}
            ></button>
            <hr />
            <button
              className="menu-item settings"
              aria-label="Settings"
              onClick={(): void => onMenuItemClick(DrawerTypes.SETTINGS)}
            ></button>
            <hr />
            <button
              className="menu-item restart"
              aria-label="Restart"
              onClick={(): void => viewerApi.restart(parentActivityId)}
            ></button>
            <hr />

            <button className="menu-item close" aria-label="Close" onClick={toggleMenu}></button>
          </div>
        </div>
      ) : (
        <button className="menu-toggle" aria-label="Open Menu" onClick={toggleMenu}></button>
      )}
    </Fragment>
  );
};
